import { i18n } from 'i18n';

export const VALIDATION_MESSAGES = () => ({
	required: i18n.t('Это поле обязательно для заполнения'),
	url: i18n.t('Введите корректный URL'),
});
